import { CartAddEvent } from '@theme/events';

const CART_DRAWER_SELECTOR = 'cart-drawer-component';

async function openCartDrawerAfterSuccessfulAdd() {
  await customElements.whenDefined('cart-drawer-component');

  const drawer = document.querySelector(CART_DRAWER_SELECTOR);
  if (!drawer) return;

  const dialog = drawer.refs?.dialog || drawer.querySelector('dialog');
  if (dialog?.open) return;

  if (typeof drawer.open === 'function') {
    drawer.open();
    return;
  }

  if (typeof drawer.showDialog === 'function') {
    drawer.showDialog();
  }
}

document.addEventListener(CartAddEvent.eventName, openCartDrawerAfterSuccessfulAdd);
